import React from 'react';
import c from 'classnames';

import type { Langcodes } from '@uncinc/react-drupal-core/types';

import MetaSearch, { type MetaSearchProps } from '../Search/MetaSearch';
import ButtonWrapper from '../ButtonWrapper';
import { constructQuery } from '../Search/MetaSearch/metaParagraphsHelpers';

import './style.scss';

export interface MoreContentProps extends Pick<MetaSearchProps, 'contentType' | 'hitsPerPage'> {
  title?: string;
  filterName: string;
  filterValue: string | number;
  buttonUrl: string;
  buttonText: string;
  langcode: Langcodes,
  className?: string;
}

const MoreContentInner:
React.FC<Pick<MoreContentProps, 'title' | 'contentType' | 'className' | 'buttonText' | 'buttonUrl'>> = (props) => {
  const {
    title,
    contentType,
    buttonUrl,
    buttonText,
    className,
  } = props;

  const classes = c('MoreContent', `MoreContent--${contentType}`, className);

  return (
    <div className={classes}>
      {title && (
        <h2 className="MoreContent__title">
          {title}
        </h2>
      )}

      <MetaSearch.Inner contentType={contentType} />

      <ButtonWrapper href={buttonUrl} type="secondary">{buttonText}</ButtonWrapper>
    </div>
  );
};


const createRandomString = (length: number) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const MoreContent: React.FC<MoreContentProps> = (props) => {
  const {
    title,
    contentType,
    hitsPerPage,
    filterName,
    filterValue,
    buttonUrl,
    buttonText,
    className,
    langcode,
  } = props;

  const salt = createRandomString(10000);

  return (
    <MetaSearch
      contentType={contentType}
      hitsPerPage={hitsPerPage}
      requestOptions={{
        getBaseFilters: () => [
          constructQuery(contentType, langcode),
          {
            bool: {
              // Show other entities of the same type
              must_not: [
                {
                  term: {
                    [filterName]: {
                      value: filterValue,
                    },
                  },
                },
              ],
            },
          },
        ],
        hooks: {
          beforeSearch: (requests) => new Promise((resolve) => {
            requests.forEach((request) => {
              request.body.sort = {
                _script: {
                  // Randomize sorting
                  script: `(doc['_id'] + "${salt}").hashCode()`,
                  type: 'number',
                  order: 'asc',
                },
              };
            });

            resolve(requests);
          }),
        },
      }}
    >
      <MoreContentInner
        title={title}
        contentType={contentType}
        className={className}
        buttonUrl={buttonUrl}
        buttonText={buttonText}
      />
    </MetaSearch>
  );
};

export default MoreContent;
